// extracted by mini-css-extract-plugin
export default {"App":"App_App__UR8qb","App-logo":"App_App-logo__7dEwk","App-logo-spin":"App_App-logo-spin__8Q9xP","App-header":"App_App-header__sqk4u","App-link":"App_App-link__zPfBq"};